import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from "@angular/core";
import {ConfirmDialogService} from "../confirm-dialog/confirm-dialog.service";
import {CirfDocument} from "../../cirf/cirf-document";
import {CirfService} from "../../cirf/cirf.service";
import {FileUploadService} from "./file-upload.service";
import {ConnectDialog} from "../confirm-dialog/connect-dialog";
import {UnityConnectTransactionType} from '../model/unity-connect-transaction-type';
import {ReferralDocument} from '../../referral/referral-document';
import {DriverLicenseInfo} from "../driver-license-info";
import {UploadedFileDescription} from "../../shared/constants";
import {DriverLicenseParsingService} from "../driver-licence-parsing/driver-licence-parsing.service";
import * as Util from "util";
import {Utils} from "../utils";
import {SystemConfigurationService} from "../configuration/system-configuration.service";
import {ConfigurationOptionValue, ConfigurationPropertNameValues} from "../configuration/system-configuration";
import {DriverLicenseParsingLogInfo, ParsingStatusValues} from '../driver-licence-parsing/driver-license-parsing-log-info';
import {
    ClientSideDriverLicenseParsing,
    GlobalLoggerService,
    LogLevelTypeValues,
    ServerSideDriverLicenseParsing
} from '../logger/global-logger.service';
import {CirfDriverLicense} from '../../cirf/cirf-driver-license';
import {MatterDocument} from "../../shared/matter-document";

const acceptedFileExtensions = '*.bmp, *.doc, *.docx, *.gif, *.jpeg, *.jpg, *.pdf, *.png, *.txt, *.tiff, *.xls, *.xlsx, *.xml, *.wpd, *.tif';

@Component({
    selector: 'dp-file-upload',
    templateUrl: './file-upload.component.html'
})
export class FileUploadComponent implements OnInit {

    @Input() acceptedExtensions: string = acceptedFileExtensions;
    @Input() sourceId: string;
    @Input() documentType: string;
    @Input() clientName: string = '';
    @Input() mortgageIndex: number;
    @Input() mortgageType: string = '';
    @Input() documentDescription: string = '';
    @Input() documentAttachedMessage: string = '';
    @Input() uploadBtnLabel: string = 'Upload';
    @Input() transactionType: UnityConnectTransactionType = 'CIRF';
    @Input() transactionId: number;
    @Input() parseBeforeUpload: boolean = false;
    @Input() elementId: string; //Used to give each instance an id so we don't get dublicate ids

    driverLicenseInfo : DriverLicenseInfo;

    @ViewChild('fileUploadInput') fileUploadInput: ElementRef;
    @Output() documentUploaded = new EventEmitter();
    @Output() prepareTransactionBeforeUpload = new EventEmitter();
    uploadInProgress: boolean;

    constructor(
        public  confirmDialogService : ConfirmDialogService,
        public cirfService : CirfService,
        public fileUploadService: FileUploadService,
        public driverLicenseParsingService: DriverLicenseParsingService,
        public systemConfigurationService: SystemConfigurationService,
        public globalLoggerService: GlobalLoggerService
        ) {

    }

    ngOnInit() {

    }

    public noUploadIssueExist(file : File) : boolean {
        let fileType = '*' + file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
        let extensions = this.acceptedExtensions.split(',').map((extension: string) => extension.trim());
        return !!extensions.find((ext: string) => ext == fileType);
    }

    initiateUpload()  {
        if(this.cirfService){
            if(this.transactionType === 'REFERRAL' && this.transactionId < 0){
                this.prepareTransactionBeforeUpload.emit();
            }
            let uploadFilesControl = this.fileUploadInput.nativeElement;
            console.log(uploadFilesControl.files);
            if (uploadFilesControl.value && uploadFilesControl.files && uploadFilesControl.files.length > 0) {
                let file: File = uploadFilesControl.files[0];
                if(this.noUploadIssueExist(file)){
                    if(this.documentDescription){
                        if(this.parseBeforeUpload && this.isParsingEnabled()){
                            // this.parseAndUploadDriverLicenseOnClient(file);
                            this.parseAndUploadDriverLicenseOnServer(file, this.documentDescription);
                        } else {
                            this.uploadFile(file, this.documentDescription);
                        }

                    } else {
                        const connectDialog = new ConnectDialog();
                        connectDialog.message = 'Please enter the file description';
                        connectDialog.dialogType = 'INFORMATION';
                        connectDialog.showInputText = true;
                        connectDialog.inputLabel = 'File Description';
                        console.log(this.transactionType);
                        if(this.transactionType === "PARTICIPATING_MATTER"){
                            connectDialog.message = 'Please enter the file description and a message to your lawyer';
                            connectDialog.showTextArea = true;
                            connectDialog.textAreaLabel = "Message to your lawyer";
                            connectDialog.textAreaText = this.documentAttachedMessage;
                        }
                        this.confirmDialogService
                            .confirmDialog(connectDialog)
                            .subscribe( (res: any) => {
                                    if (res && res.isOkClicked) {
                                        // preserve textArea
                                        this.documentAttachedMessage = res.textAreaText;
                                        this.uploadFile(file, res.inputText, res.textAreaText);
                                    }
                                }
                            );
                    }
                } else {
                    let connectDialog = new ConnectDialog();
                    connectDialog.message = `File type not supported for upload. Supported files are:${this.acceptedExtensions}.`;
                    connectDialog.dialogType = 'ERROR';
                    connectDialog.showCancelBtn = false;
                    this.confirmDialogService
                        .confirmDialog(connectDialog).subscribe();
                }
            }
        }

    }

    isParsingEnabled() : boolean {
        if(this.systemConfigurationService && this.systemConfigurationService.systemConfiguration){
            let licenseParsingConfigurationValue : ConfigurationOptionValue =
                this.systemConfigurationService.systemConfiguration.getConfigurationValueByProperty(ConfigurationPropertNameValues.licenseParsingEnabled);
            return licenseParsingConfigurationValue && licenseParsingConfigurationValue.configurationValue == 'true';
        } else {
            return false;
        }
    }

    // Adding '--' to the clientName as an indicator for the backend
    // TODO Backend should update the file name with the correct clinetName from the Cirf
    // Incorrect clientName may happen if parsing driver license fails or uploading the front of the driver license before the back
    updateClientName(description: string) {
        if(this.parseBeforeUpload){
            if(this.driverLicenseInfo && this.driverLicenseInfo.clientName){
                this.clientName = this.driverLicenseInfo.clientName;
            } else {
                this.clientName = (this.clientName ? this.clientName : this.sourceId) + '--';
            }
        } else {
            if(description == UploadedFileDescription.driverLicenseFront || description == UploadedFileDescription.driverLicenseBack){
                if(this.clientName){
                    this.clientName += '--';
                } else {
                    this.clientName = this.sourceId + '--';
                }
            }
        }
    }

    parseAndUploadDriverLicenseOnClient(file: File) {
        if (Utils.isIE()) {
            this.showParsingIEErrorMessage(file);
        } else {
            this.driverLicenseParsingService.parseDriverLicense(file, this.handleParsingComplete, this.handleFailToParse);
        }
    }

    parseAndUploadDriverLicenseOnServer(file: File, description: string) {
        const startTime = performance.now();
        this.uploadInProgress = true;
        const formData = new FormData();
        formData.append('uploadedFile', file, file.name);
        this.updateClientName(description);
        if (this.clientName) {
            formData.append('clientName', this.clientName);
        }
        if (description) {
            formData.append('description', description);
        }
        this.driverLicenseParsingService.parseAndUploadDriverLicense(formData, this.cirfService.cirf.guid, this.sourceId)
            .subscribe((cirfDriverLicense: CirfDriverLicense) => {
                    console.log(cirfDriverLicense);
                    this.uploadInProgress = false;
                    if(cirfDriverLicense && cirfDriverLicense.driverLicenseInfoDTO && cirfDriverLicense.driverLicenseInfoDTO.success) {
                        this.driverLicenseInfo = new DriverLicenseInfo(cirfDriverLicense.driverLicenseInfoDTO);
                        this.documentUploaded.emit({
                            cirfDocument: new CirfDocument(cirfDriverLicense.unityConnectDocumentDTO),
                            driverLicenseInfo: new DriverLicenseInfo(cirfDriverLicense.driverLicenseInfoDTO)
                        });
                        const driverLicenseParsingLogInfo = this.driverLicenseParsingService.createDriverLicenseParsingLogInfo(ParsingStatusValues.success, Utils.calculateDuration(startTime), 'Success', file, true);
                        this.logParsingInformation(driverLicenseParsingLogInfo);
                    } else {
                        const driverLicenseParsingLogInfo = this.driverLicenseParsingService.createDriverLicenseParsingLogInfo(ParsingStatusValues.failure, Utils.calculateDuration(startTime), 'Server couldn\'t scan image', file, true);
                        this.handleFailToParse(file, driverLicenseParsingLogInfo);
                    }
                },
                (error) => {
                    console.log(error);
                    let errorMessage = error.toString();
                    this.uploadInProgress = false;
                    if (error.name === 'TimeoutError') {
                        errorMessage = 'Time out';
                    }
                    const driverLicenseParsingLogInfo = this.driverLicenseParsingService.createDriverLicenseParsingLogInfo(ParsingStatusValues.failure, Utils.calculateDuration(startTime), errorMessage, file, true);
                    if (error?.error?.Error?.errorCode === 'app.document.VirusScanError' || error?.error?.Error?.errorCode === 'app.document.InfectedWithVirus') {
                        this.handleVirusScanError(driverLicenseParsingLogInfo);
                    } else {
                        this.handleFailToParse(file, driverLicenseParsingLogInfo);
                    }
                }
            );
    }

    uploadFile(file: File, description: string, documentAttachedMessage?: string) {
        if (this.transactionType === 'CIRF' && this.cirfService.cirf) {
            this.uploadCirfFile(file, description);
        } else if (this.transactionType === 'REFERRAL') {
            this.uploadReferralFile(file, description);
        } else if (this.transactionType === 'PARTICIPATING_MATTER') {
            this.uploadMatterInfoFile(file, description, documentAttachedMessage);
        }
    }

    uploadCirfFile(file: File, description: string) {
        this.uploadInProgress = true;
        let formData = new FormData();
        formData.append('uploadedFile', file, file.name);
        if(description){
            formData.append('description', description);
        }
        this.updateClientName(description);
        if(this.clientName){
            formData.append('clientName', this.clientName);
        }
        if(this.mortgageType){
            formData.append('mortgageType', this.mortgageType);
        }
        if(this.mortgageIndex){
            formData.append('mortgageIndex', String(this.mortgageIndex));
        }
        this.fileUploadService.uploadCirfFiles(formData, this.cirfService.cirf.guid, this.sourceId, this.documentType)
            .subscribe((cirfDocument: CirfDocument)=>{
                    console.log(cirfDocument);
                    this.uploadInProgress = false;
                    this.documentUploaded.emit({ cirfDocument: cirfDocument, driverLicenseInfo: this.driverLicenseInfo });
                },
                (error)=>{
                    console.log(error);
                    this.uploadInProgress = false;
                }
            );
    }

    uploadReferralFile(file: File, description: string) {
        this.uploadInProgress = true;
        let formData = new FormData();
        formData.append('uploadedFile', file, file.name);
        if(description){
            formData.append('description', description);
        }
        this.fileUploadService.uploadReferralFiles(formData, this.transactionId)
            .subscribe((referralDocument: ReferralDocument)=>{
                    console.log(referralDocument);
                    this.uploadInProgress = false;
                    this.documentUploaded.emit({ referralDocument: referralDocument });
                },
                (error)=>{
                    console.log(error);
                    this.uploadInProgress = false;
                }
            );
    }

    get acceptedFileExtensions(): string {
        return this.acceptedExtensions.replace(/\*/g, '');
    }

    handleParsingComplete = (file: File, driverLicenseInfo: DriverLicenseInfo, driverLicenseParsingLogInfo: DriverLicenseParsingLogInfo) =>{
        this.driverLicenseInfo = driverLicenseInfo;
        this.logParsingInformation(driverLicenseParsingLogInfo);
        this.uploadFile(file, this.documentDescription);
    };

    handleFailToParse = async (file: File, driverLicenseParsingLogInfo: DriverLicenseParsingLogInfo) =>{
        this.driverLicenseInfo = null;
        if (driverLicenseParsingLogInfo) {
            this.logParsingInformation(driverLicenseParsingLogInfo);
        }
        let tryAnotherFile = await this.showParsingErrorMessage();
        //If the user selects not to try again
        if(!tryAnotherFile){
            //Upload the same file
            this.uploadFile(file, this.documentDescription);
        } else {
            //Set the value of the selected files to null to be able to fire the change() event if the user select the same file again.
            this.fileUploadInput.nativeElement.value = null;
        }
    };

    handleVirusScanError(driverLicenseParsingLogInfo: DriverLicenseParsingLogInfo) {
        this.driverLicenseInfo = null;
        this.logParsingInformation(driverLicenseParsingLogInfo);
        this.fileUploadInput.nativeElement.value = null;
    };

    logParsingInformation(driverLicenseParsingLogInfo: DriverLicenseParsingLogInfo) {
        const logMessage = ((driverLicenseParsingLogInfo.completedOnServer) ? ServerSideDriverLicenseParsing : ClientSideDriverLicenseParsing) +
            ';parsingStatus=' + driverLicenseParsingLogInfo.status +
            ';reason=' + driverLicenseParsingLogInfo.failureReason +
            ';parsingDuration=' + driverLicenseParsingLogInfo.duration +
            ';fileSize=' + driverLicenseParsingLogInfo.fileSize +
            ';fileName=' + driverLicenseParsingLogInfo.filename ;
        this.globalLoggerService.log(LogLevelTypeValues.INFO, logMessage);
    }

    async showParsingErrorMessage(){
        let connectDialog = new ConnectDialog();
        connectDialog.message = "We were unable to extract the information from the barcode on the uploaded Driver's Licence. " +
            "We recommend uploading a clearer image. <br>If you choose to continue with the image already provided, " +
            "you will be required to manually enter in the details of the Driver’s Licence.";
        connectDialog.dialogType = 'WARNING';
        connectDialog.okBtnText = 'Upload again';
        connectDialog.cancelBtnText = 'Continue with current image';
        return await this.confirmDialogService.confirmDialog(connectDialog).toPromise();
    };

    showParsingIEErrorMessage(file: File) : void {
        let connectDialog = new ConnectDialog();
        connectDialog.message = 'Driver’s Licence bar code parsing is not supported in Internet Explorer, please enter Driver’s Licence information manually';
        connectDialog.dialogType = 'ERROR';
        connectDialog.showCancelBtn = false;
        this.confirmDialogService.confirmDialog(connectDialog).subscribe(
            res => {
                if(res) {
                    this.uploadFile(file, this.documentDescription);
                }
            }
        );
    };

    uploadMatterInfoFile(file: File, description: string, documentAttachedMessage: string) {
        this.uploadInProgress = true;
        const formData = new FormData();
        formData.append('uploadedFile', file, file.name);
        if(description){
            formData.append('description', description);
        }
        if(documentAttachedMessage){
            formData.append('messageToRecipients', documentAttachedMessage);
        }
        this.fileUploadService.uploadMatterInfoFiles(formData, this.sourceId)
            .subscribe((matterDocument: MatterDocument)=>{
                    console.log(matterDocument);
                    this.uploadInProgress = false;
                    this.documentUploaded.emit({ matterDocument: matterDocument });
                },
                (error)=>{
                    console.log(error);
                    this.uploadInProgress = false;
                }
            );
    }
}
